var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-toolbar',{staticClass:"kp-sublime-toolbar",attrs:{"color":"transparent","elevation":"0","height":_setup.calcHeight}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }